import SbgSignalAnalytics from 'utils/SbgSignalAnalytics';
import GoogleAnalytics from 'utils/GoogleAnalytics';
import OmnitureAnalytics from 'utils/OmnitureAnalytics';

export default function getMetricsConfig(store, config) {
  const {signal, google, omniture} = config.metricsVendors;

  return {
    vendors: [
      getVendor(signal, SbgSignalAnalytics, store),
      getVendor(google, GoogleAnalytics),
      getVendor(omniture, OmnitureAnalytics, store)
    ],
    pageDefaults: routeState => {
      const paths = routeState.pathname.substr(1).split("/");
      const timestamp = new Date();
  
      return {
        timestamp,
        build: 1,
        siteName: "sptlfe-dev",
        category: !paths[0] ? "landing" : paths[0]
      };
    },
    pageViewEvent: "pageView"
  }

}

function getVendor(vendorConfig, apiClass, store = {}) {
  const vendorSetup = vendorConfig.setup;
  return {name: vendorConfig.name, api: new apiClass(vendorSetup, store)};
}


// WEBPACK FOOTER //
// ./utils/metricsConfig.js